import { trackPromise } from "react-promise-tracker";
import { IHospitalPrescriptionModel, HospitalPrescriptionModel } from "@common/models/HospitalPrescriptionModel";
import { http } from "@common/utils";
import { IRXServiceDispensingHistoryItemModel, RXServiceDispensingHistoryItemModel } from "@common/models/RXServiceDispensingHistoryItemModel";
import { IRxSKUItemModel, RxSKUItemModel } from "@common/models/RxSKUItemModel";
import { IDispensingHistoryRequest } from "@common/models/requests/DispensingHistoryRequest";

export class PrescriptionService {
    private static baseUrl: string = '/api/prescription';

    public static tags = {
        getByHospitalPrescriptionId: "getByHospitalPrescriptionId",
        getRXDispensingHistory: "getRXDispensingHistory",
        getRXSKUQuantities: "getRXSKUQuantities",
        recallHospitalPrescription: "recallHospitalPrescription",
        transferHospitalPrescription: "transferHospitalPrescription"
    }

    static getHospitalPrescription = (hospitalPrescriptionId: number): Promise<HospitalPrescriptionModel> =>
        trackPromise(new Promise<HospitalPrescriptionModel>((resolve, reject) => {
            http(`${this.baseUrl}/hospital/${hospitalPrescriptionId}`)
                .get<IHospitalPrescriptionModel>()
                .then(json => resolve(new HospitalPrescriptionModel(json)))
                .catch(reject)
        }), this.tags.getByHospitalPrescriptionId);

    static getRXDispensingHistory = (request: IDispensingHistoryRequest): Promise<RXServiceDispensingHistoryItemModel[]> =>
        trackPromise(new Promise<RXServiceDispensingHistoryItemModel[]>((resolve, reject) => {
            http(`${this.baseUrl}/hospital/dispensinghistory`)
                .post<IRXServiceDispensingHistoryItemModel[]>(request)
                .then(response => resolve(response.map(d => new RXServiceDispensingHistoryItemModel(d))))
                .catch(reject)
        }), this.tags.getRXDispensingHistory)

    static getRXSKUQuantities = (): Promise<RxSKUItemModel[]> =>
        trackPromise(new Promise<RxSKUItemModel[]>((resolve, reject) => {
            http(`${this.baseUrl}/hospital/skuquantities`)
                .get<IRxSKUItemModel[]>()
                .then(response => resolve(response.map(d => new RxSKUItemModel(d))))
                .catch(reject)
        }), this.tags.getRXSKUQuantities);

    static recallHospitalPrescription = (hospitalPrescriptionId: number): Promise<HospitalPrescriptionModel> =>
        trackPromise(new Promise<HospitalPrescriptionModel>((resolve, reject) => {
            http(`${this.baseUrl}/hospital/recall/${hospitalPrescriptionId}`)
                .post<IHospitalPrescriptionModel>({})
                .then(json => resolve(new HospitalPrescriptionModel(json)))
                .catch(reject)
        }), this.tags.recallHospitalPrescription);

    static transferHospitalPrescription = (hospitalPrescriptionId: number, note: string): Promise<HospitalPrescriptionModel> =>
        trackPromise(new Promise<HospitalPrescriptionModel>((resolve, reject) => {
            http(`${this.baseUrl}/hospital/transferpermanent`)
                .post<IHospitalPrescriptionModel>({ hospitalPrescriptionId, note })
                .then(json => resolve(new HospitalPrescriptionModel(json)))
                .catch(reject)
        }), this.tags.transferHospitalPrescription);
}
